import i18n from "@/assets/i18n/i18n"
import _ from 'lodash'
// import { initialStoreModules, initialMainStore } from "./store.js"

export default {
    // setInitialStoreModules(state) {
    //     _.forOwn(initialMainStore, (value, key) => {
    //         state[key] = _.cloneDeep(value);
    //     });
    //     _.forOwn(initialStoreModules, (value, key) => {
    //         state[key] = _.cloneDeep(value.state);
    //     });
    // },
    // General Application Data
    // setIsLoggedIn() {
    //     if(JSON.parse(localStorage.getItem('userData'))) store.state.isLoggedIn = true
    //     else store.state.isLoggedIn = false
    // }, 
    // Navigation menu
    setDrawer: (state, value) => { state.drawer = value },
    setOpenDriver: (state, value) => { state.openDriver = value },

    setIsLoggedIn: (state, islogged) => { state.isLoggedIn = islogged }, 
    setPrevRoute: (state, prevRoute) => { state.prevRoute = prevRoute },
    setI18nMessages(state, languageFromDB) { i18n.setLocaleMessage(i18n.locale, languageFromDB) },     
    
    // User-Object   
    setUser: (state, user) => { state.user = user },
    setUserCustomerCompany: (state, company) => { state.user.customerCompany = company },
    setUserCustomerNumber: (state, number) => { state.user.customerNumber = number },
    setUserLanguage: (state, lang) => { state.user.language = lang },
    setUserUsername: (state, username) => { state.user.username = username },    
    setSelectedCurrency(state) {
        if(state.isLoggedIn) state.selectedCurrency = JSON.parse(localStorage.getItem('userData'))['user']['currency']
    },
    setHomeSociety(state) {
        if(state.isLoggedIn) state.selectedCurrency = JSON.parse(localStorage.getItem('userData'))['user']['homeSociety']
    },
    setHomeSocietyCode(state) {
        if(state.isLoggedIn) state.selectedCurrency = JSON.parse(localStorage.getItem('userData'))['user']['homeSocietyCode']
    },
    setCompanyCountry(state) {
        if(state.isLoggedIn) state.companyCountry = JSON.parse(localStorage.getItem('userData'))['user']['companyCountry']
    },

    // Paging
    setTotalRecords: (state, total) => { state.totalRecords = total },
    setTotalListed: (state, total) => { state.totalListed = total },
    setCurrentPage: (state, page) => { state.currentPage = page },
    setItemsPerPage: (state, amount) => { state.itemsPerPage = amount },
    setNumberOfPages: (state, pages) => { state.numberOfPages = pages },

    // Searchdialog "paging"
    setTotalRecordsSearchDialog: (state, total) => { state.totalRecordsSearchDialog = total },
    setTotalListedSearchDialog: (state, total) => { state.totalListedSearchDialog = total },

    // Publihsing & Label Companies (options & current selected)
    setPublishingCompanies(state) {
        if(state.isLoggedIn) state.publishingCompanies = JSON.parse(localStorage.getItem('userData'))['publishingCompanies']
    },
    setLabelCompanies(state) {
        if(state.isLoggedIn) state.labelCompanies = JSON.parse(localStorage.getItem('userData'))['labelCompanies']
    },

    setSelectedOverAllCompany: (state, company) => { 
        if(company) state.selectedOverAllCompany = company
        if(company === undefined) state.selectedOverAllCompany = JSON.parse(localStorage.getItem('userData'))['selectedOverAllCompany'] 
    },

    setSelectedPublishingCompanyId: (state, id) => { 
        if(id) state.selectedPublishingCompanyId = id
        if(state.isLoggedIn && id === undefined) state.selectedPublishingCompanyId = JSON.parse(localStorage.getItem('userData'))['selectedPublishingCompanyId']
    },
    setSelectedLabelCompanyId: (state, id) => {
        if(id) state.selectedLabelCompanyId = id
        if(state.isLoggedIn && id === undefined) state.selectedLabelCompanyId = JSON.parse(localStorage.getItem('userData'))['selectedLabelCompanyId']
    },

    // Dropdown options
    setCountries(state) { state.countries = JSON.parse(localStorage.getItem('userData'))['countries'] },
    
    setPublishingContractsTypes(state) { state.publishingContractsTypes = JSON.parse(localStorage.getItem('userData'))['publishingContractsTypes'] },

    setCountriesDE: (state, de) => { state.countries.de = de},
    setCountriesEN: (state, en) => { state.countries.en = en},  
    
    setAzTypes(state) { state.azTypes = JSON.parse(localStorage.getItem('userData'))['azTypes'] },
    setAzTypesDE: (state, de) => { state.azTypes.de = de },
    setAzTypesEN: (state, en) => { state.azTypes.en = en},

    setApiConnections(state){state.apiConnections = JSON.parse(localStorage.getItem('userData'))['apiConnections']},

    setInterests(state){state.interests = JSON.parse(localStorage.getItem('userData'))['interests']},

    setDealflow(state) { state.dealflow = JSON.parse(localStorage.getItem('userData'))['dealflow'] },
    setDealflowDE: (state, de) => { state.dealflow.de = de },
    setDealflowEN: (state, en) => { state.dealflow.en = en },

    setVisibility(state) { state.visibility = JSON.parse(localStorage.getItem('userData'))['visibility'] },
    setVisibilityDE: (state, de) => { state.visibility.de = de },
    setVisibilityEN: (state, en) => { state.visibility.en = en },

    setGeneralLanguages: (state) => { state.generalLanguages = JSON.parse(localStorage.getItem('userData'))['generalLanguageOptions'] },

    setGenres(state) { state.genres = JSON.parse(localStorage.getItem('userData'))['genres'] },
    setGenresDE: (state, de) => { state.genres.de = de },
    setGenresEN: (state, en) => { state.genres.en = en },

    setLanguages(state) { state.languages = JSON.parse(localStorage.getItem('userData'))['languages'] },
    setLanguagesDE: (state, de) => { state.languages.de = de },
    setLanguagesEN: (state, en) => { state.languages.en = en },

    setPublishingTypeOfRights(state) { state.publishingTypeOfRights = JSON.parse(localStorage.getItem('userData'))['publishingTypeOfRights'] },
    setPublishingTypeOfRightsGema: (state, gema) => { state.publishingTypeOfRights.gema = gema },
    setPublishingTypeOfRightsSvd: (state, svd) => { state.publishingTypeOfRights.svd = svd },

    setLabelStatisticsInRows(state) { state.labelStatisticsInRows = JSON.parse(localStorage.getItem('userData'))['labelStatisticsInRows'] },
    setLabelStatisticsInRowsAzTypes: (state, types) => { state.labelStatisticsInRows.azTypes = types },
    setLabelStatisticsInRowsDistributors: (state, values) => { state.labelStatisticsInRows.distributors = values },
    setLabelStatisticsInRowsProduct: (state, values) => { state.labelStatisticsInRows.product = values },
    
    setLicensors(state) { state.licensors = JSON.parse(localStorage.getItem('userData'))['licensors'] },
    setSocieties(state) { state.societies = JSON.parse(localStorage.getItem('userData'))['societies'] },
    setWorkStyles(state) { state.workStyles = JSON.parse(localStorage.getItem('userData'))['workStyles'] },

    setReleaseGemaMediaTypes( state ) { return state.releaseGemaMediaTypes = JSON.parse(localStorage.getItem('userData'))['releaseGemaMediaTypes'] },
    setReleaseMediaTypes( state ) { return state.releaseMediaTypes = JSON.parse(localStorage.getItem('userData'))['releaseMediaTypes'] },

    setInstrumentations(state) { return state.instrumentations = JSON.parse(localStorage.getItem('userData'))['instrumentations'] },

    // General page data for lists
    setIsLoading: (state, isLoading) => { state.isLoading = isLoading },
    setNoDataText: (state, noDataText) => { state.noDataText = noDataText },

    // Dialogs , Snackbars, Alerts
    setSnackbar: (state, snackbar) => { state.snackbar = snackbar },
    setSelectionRequieredAlert: (state, show) => { state.selectionRequieredAlert = show },
    setSelectionRequiredText: (state, text) => { state.selectionRequiredText = text },
    setShowSelectionRequiredDialog: (state, show) => { state.showSelectionRequiredDialog = show },
    setShowPeriodRequiredDialog: (state, show) => { state.showPeriodRequiredDialog = show },
    setShowDeletionDialog: (state, show) => { state.showDeletionDialog = show },
    setDeletionDialogContext: (state, context) => { state.deletionDialogContext = context },
    setShowMoveContractsDialog: (state, show) => { state.showMoveContractsDialog = show },
    setShowConnectArtistDialog: (state, show) => { state.showConnectArtistDialog = show },
    setShowStatementPreviewDialog: (state, show) => { state.showStatementPreviewDialog = show },
    setConfirmationDialog: (state, value )      => { state.confirmationDialog = value },
    setShowConfirmationDialog: (state, value )      => { state.confirmationDialog.show = value },
    setResolveCallbackConfirmationDialog: (state, value )  => { 
        if(state.confirmationDialog.resolveCallback) { 
            state.confirmationDialog.resolveCallback(value)
            state.confirmationDialog.resolveCallback = null 
        }
        state.confirmationDialog.result = value
    },
    setShowMediaFileUploadDialog: (state, context) => { state.showMediaFileUploadDialog = context },
    // setShowDeletionDialogProlists: (state, show) => { state.showDeletionDialogProlists = show },
    // setShowDeletionDialogMyMapping: (state, show) => { state.showDeletionDialogMyMapping = show },
    setShowGemaWorksCheckDialog: (state, show) => { state.showGemaWorksCheckDialog = show},
    setShowSearchDialog: (state, show) => { state.showSearchDialog = show },
    
    // Persons Dialog
    setPersonsPanelEntry: (state, persons) => { state.personsPanelEntry = persons },
    setSelectedPersonsPanelEntry: (state, selected) => { state.selectedPersonsPanelEntry = selected },
    setPersonsPanelEntryEditingDialogDetails: (state, details) => { state.personsPanelEntryEditingDialogDetails = details },
    setDefaultPersonsPanelEntry: (state) => { state.defaultPersonsPanelEntry = DEFAULT_PERSONS },
    setPersonsPanelEntryPersonOptions: (state, options) => { state.personsPanelEntryPersonOptions = options },
    setPersonsPanelEntryDetailsPerson: (state, person) => { state.selectedPersonPersonsPanelDialog = person },
    setPersonsPanelEntryDetailsMobil: (state, mobil) => { state.personsPanelEntryEditingDialogDetails.cellphone = mobil },
    setPersonsPanelEntryDetailsEmail: (state, email) => { state.personsPanelEntryEditingDialogDetails.email = email },
    setPersonsPanelEntryDetailsRole: (state, role) => { state.personsPanelEntryEditingDialogDetails.role = role },
    setPersonsPanelEntryDetailsInheritFromGroup: (state, inherit) => { state.personsPanelEntryEditingDialogDetails.inheritFromGroup = inherit },
    setPersonsPanelEntryDetailsId: (state, id) => { state.personsPanelEntryEditingDialogDetails.id = id },
    setPersonsPanelEntryDetailsFirstName: (state, name) => { state.personsPanelEntryEditingDialogDetails.firstName = name },
    setPersonsPanelEntryDetailsLastName: (state, name) => { state.personsPanelEntryEditingDialogDetails.lastName = name },
    setPersonsPanelEntryDetailsKeyName: (state, name) => { state.personsPanelEntryEditingDialogDetails.gemaName = name },

    // Error Dialog
    setShowErrorDialog: (state, show) => { state.showErrorDialog = show },
    setErrorMessageCode: (state, code) => { state.errorMessageCode = code },
    setErrorDialogCsvLink: (state, link) => { state.errorDialogCsvLink = link },
    setErrorDialogMessage: (state, msg) => { state.errorDialogMessage = msg },
    
    // File Import Dialog
    setSelectedFileImportOption: (state, option) => { state.selectedFileImportOption = option },
    setSelectedFileImport: (state, selectedFileImport) => { state.selectedFileImport = selectedFileImport },
    setSelectedFileUploadOption: (state, option) => { state.selectedFileUploadOption = option },
    setShowFileImportDialog: (state, show) => { state.showFileImportDialog = show },
    setImportDialogText: (state, text) => { state.importDialogText = text},
    setUploadPictureDialogText: (state, text) => { state.uploadPictureDialogText = text},
    setSelectedPeriodValuesImportDialog: (state, value) => { state.selectedPeriodValuesImportDialog = value },
    setSelectedPeriodNumberImportDialog: (state, value) => { state.selectedPeriodValuesImportDialog.num = value },
    setSelectedPeriodTimeUnitImportDialog: (state, value) => { state.selectedPeriodValuesImportDialog.period = value },
    setSelectedPeriodYearImportDialog: (state, value) => { state.selectedPeriodValuesImportDialog.year = value },
    setSelectedImportDialogCheckboxes: (state, value) => { state.selectedImportDialogCheckboxes = value },

    //Report Options dropdown
    setSelectedFileReport: (state, report) => { state.selectedFileReport = report },

    // Run Error List Dialog
    setShowRunErrorListDialog: (state, show) => { state.showRunErrorListDialog = show },
    setRunErrorListDialogText: (state, text) => { state.runErrorListDialogText = text },
    setRunErrorListDialogProgressValue: (state, value) => { state.runErrorListDialogProgressValue  = value },
    setRunErrorListDialogPolling: (state, polling) => { state.runErrorListDialogPolling = polling },

    // Inline Editing Dialog (Listpage)
    setShowInlineEditingDialog: (state, show) => { state.showInlineEditingDialog = show },

    // Regions Dialog
    setShowRegionDialog: (state, show) => { state.showRegionDialog = show },
    setRegionDialogIncludeOptions: (state, options) => { state.regionDialogIncludeOptions = options },
    setRegionDialogExcludeOptions: (state, options) => { state.regionDialogExcludeOptions = options },
    setRegionDialogDetailsInclude: (state, include) => { state.regionDialogDetailsInclude = include },
    setRegionDialogDetailsExclude: (state, exclude) => { state.regionDialogDetailsExclude = exclude },

    // Editing Dialog
    setShowEditingDialog: (state, show) => { state.showEditingDialog = show },
    setEditingDialogHeadline: (state, headline) => { state.editingDialogHeadline = headline },

    // Manage Tags Dialog
    setShowManageTagsDialog: (state, show) => { state.showManageTagsDialog = show },
    setAddTag: (state, tag) => { state.addTag = tag },
    setRemoveTag: (state, tag) => { state.removeTag = tag },
    
    //Manage Sync Data Dialog 
    setShowSyncDataDialog: (state,show) => {state.showSyncDataDialog = show},
    
    // Digital Platforms
    setDigitalPlatforms: (state) => { state.digitalPlatforms = JSON.parse(localStorage.getItem('userData'))['digitalPlatforms'] },

    // File Bulk Import
    setShowFileBulkImportDialog: (state, show) => { state.showFileBulkImportDialog = show },
    setSelectedFileBulkImport: (state, selectedFileImport) => { state.selectedFileBulkImport = selectedFileImport },
    setSelectedFileReportDataBulkImport: (state, reportData) => { state.selectedFileReportDataBulkImport = reportData },
    setSelectedFileRecordsBulkImport: (state, records) => { state.selectedFileRecordsBulkImport = records },
    setSelectedFileBulkImportUploader: (state, show) => { state.selectedFileBulkImportUploader = show },
    setShowDragAndDropUploader: (state, show) => { state.showDragAndDropUploader = show },
    setFileBulkUploaderFileRecordsForUpload: (state, value) => { state.fileBulkUploaderFileRecordsForUpload = value },
    setFileBulkUploaderUploadUrl: (state, value) => { state.fileBulkUploaderUploadUrl = value },
    setFileBulkUploaderUploadHeaders: (state, value) => { state.fileBulkUploaderUploadHeaders = value },
    setFileBulkUploaderDeletable: (state, value) => { state.fileBulkUploaderDeletable = value },
    setFileBulkUploaderReadonly: (state, value) => { state.fileBulkUploaderReadonly = value },
    setFileBulkUploaderDetailsTag: (state, value) => { state.fileBulkUploaderDetailsTag = value },
    setFileBulkUploaderDetailsSelectedLabelId: (state, value) => { state.fileBulkUploaderDetailsSelectedLabelId = value },
    setFileBulkUploaderLabelsDropdown(state, value) {  state.fileBulkUploaderLabelsDropdown = value},

    //Drag&&Drop Uploader
    setSelectedImageUploadFile: (state, value) => { state.selectedImageUploadFile = value },
    setShowUploadBtnDragAndDropUploader: (state, value) => { state.showUploadBtnDragAndDropUploader = value },
    setImageUploaderImageExists: (state, value) => { state.imageUploaderImageExists = value },
    setShowImageUploadDialog: (state, show) => { state.showImageUploadDialog = show },
    setImageUploaderContext: (state, context) => { state.imageUploaderContext = context },

    //ImageUploadOnly
    setShowImageUploadOnlyDialog: (state, show) => { state.showImageUploadOnlyDialog = show },
    //Drag&&Drop Media Uploader
    setSelectedMediaUploadFiles: (state, value) => { state.selectedMediaUploadFiles = value },

    // setShowDialogText: (state, showDialogText) => { state.showDialogText = showDialogText },
    setUploadProgressbarValue: (state, value) => { state.uploadProgressbarValue = value },

    // General Period Filter Component
    setBalanceInNumbersSelected: (state, number) => {  state.balanceInNumbersSelected = number },
    setBalanceInTimeUnitSelected: (state, timeUnit) => {  state.balanceInTimeUnitSelected = timeUnit },
    setBalanceInYearSelected: (state, year) => {  state.balanceInYearSelected = year },

    setContractsRights(state) { state.contractsRights = JSON.parse(localStorage.getItem('userData'))['contractRights'] },
    // setContractsRightsDE(state, de) { state.contractsRights.de = de },
    // setContractsRightsEN(state, en) { state.contractsRights.en = en },

    // setContractsApplyTo(state) { state.contractsApplyTo = JSON.parse(localStorage.getItem('userData'))['contractApplyTo'] },
    setAccountCredentialsType(state) { state.accountCredentialsType = JSON.parse(localStorage.getItem('userData'))['credentialsType'] },
    setUserInformation(state) { state.userInformation = JSON.parse(localStorage.getItem('userData'))['user'] },

    setAudio:(state, value) => { state.audio = value },

    // Importers for Listpages
    setListpageImporters:                               (state, value) => { state.listpageImporters = value },

    // Data sharing dialog
    setShowDataSharingDialog:                           (state, value) => { state.showDataSharingDialog = value },
}